import { render, staticRenderFns } from "./genericElementTile.vue?vue&type=template&id=65c994b9"
import script from "./genericElementTile.vue?vue&type=script&lang=js"
export * from "./genericElementTile.vue?vue&type=script&lang=js"
import style0 from "./genericElementTile.vue?vue&type=style&index=0&id=65c994b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports